module.exports = __webpack_public_path__ + "img/files.67292181.svg";